'use strict';

/**
 * Acquisitions: leads brought in by the sales team, to approve as customers / partners / REOs / vendors.
 * Tiles (Total, Interested, Not Interested, Approved) show the counts for the current filters and filter the list
 * when clicked; the filters bar has dates, interest, approval and a name / mobile search; the list is paged on
 * the server (50 per page). Filters and page are kept in the URL (Back / refresh keep the view).
 */
angular.module('scrapQcrmApp')
  .controller('AquisitionCtrl', function ($scope, tableState, $http, $state, $rootScope, dashboard, $uibModal, $log, $global, consumer, wholesalerService, growl, BidService, $moment) {

    var PAGE_SIZE = 50;
    var STATUS = { ALL: 'ALL', INTERESTED: 'COMPLETED', NOT_INTERESTED: 'PENDING' }; // values the Sales API expects

    // ---- filters (defaults = the old page: not approved yet, any interest, any date) ----
    $scope.filters = {
      status: STATUS.ALL,
      approval: 'not_approved', // all | approved | not_approved
      search: ''
    };
    $scope.date = { startDate: null, endDate: null };
    $scope.pager = { page: 1, size: PAGE_SIZE };
    $scope.searchText = '';
    $scope.counts = { total: null, interested: null, notInterested: null, approved: null };
    $scope.listTotal = 0;
    $scope.loading = false;
    $scope.loadError = false;
    $scope.consumer_list = [];

    $scope.tiles = [
      { key: "total", label: "Total", style: { color: "#21a548" } },
      { key: "interested", label: "Interested", style: { color: "#337ab7" } },
      { key: "notInterested", label: "Not Interested", style: { color: "#f0ad4e" } },
      { key: "approved", label: "Approved", style: { color: "#21a548" } }
    ];

    $scope.statusOptions = [
      { value: STATUS.ALL, label: 'All' },
      { value: STATUS.INTERESTED, label: 'Interested' },
      { value: STATUS.NOT_INTERESTED, label: 'Not Interested' }
    ];
    // the older Sales API needs approved / not approved and has no text search (see salesApiUpdated in app.js)
    $scope.salesApiUpdated = $global.salesApiUpdated;
    $scope.approvalOptions = [
      { value: 'all', label: 'All' },
      { value: 'approved', label: 'Approved' },
      { value: 'not_approved', label: 'Not Approved' }
    ].filter(function (o) { return $scope.salesApiUpdated || o.value !== 'all'; });

    // ---- grid ----
    (function () {
      var columnDefs = [
        {
          headerName: "Approve",
          cellRenderer: ApproveCellRenderer,
          resizable: true,
          maxWidth: 120,
          cellStyle: { 'height': '100%', 'display': 'flex', 'align-items': 'center', 'justify-content': 'center' }
        },
        {
          headerName: "UserType",
          field: "userType",
          maxWidth: 120,
          valueFormatter: function (params) {
            return params.data.userType || 'Customer';
          }
        },
        {
          headerName: "Sales Person Name",
          field: "addedBy.name",
          valueFormatter: function (params) {
            return params.value || '-'; // the agent record may no longer exist
          }
        },
        { headerName: "Business Name", field: "organizationName" },
        { headerName: "Customer Name", field: "name" },
        { headerName: "Mobile Number", field: "mobileNo", cellStyle: { 'text-align': 'center' } },
        { headerName: "Area", field: "address.address", cellStyle: { 'text-align': 'left', 'margin-left': '10px' } },
        {
          headerName: "Inception Date",
          field: "createdAt",
          valueFormatter: function (params) {
            return params.value ? $moment(params.value).format('YYYY-MM-DD HH:mm:ss') : '';
          }
        },
        { headerName: "Interested", field: "status", maxWidth: 120 },
        {
          headerName: "Approved", field: "isApproved", maxWidth: 120,
          valueFormatter: function (params) { return params.value ? 'Yes' : 'No'; }
        },
        { headerName: "Customer Type", field: "categories.value" }
      ];

      $scope.gridOptions = {
        columnDefs: columnDefs,
        // the server pages and orders the list (newest first); filtering is done by the filters bar above
        defaultColDef: { flex: 1, minWidth: 130, filter: false, sortable: false, resizable: true },
        rowStyle: { background: '#f4f4f4' },
        rowData: [],
        suppressCsvExport: false,
        suppressExcelExport: false,
        overlayNoRowsTemplate: '<span class="text-muted">No acquisitions for these filters</span>',
        getRowStyle: function (params) {
          if (params.node.rowIndex % 2 === 0) {
            return { background: 'white' };
          }
        },
        onGridReady: function (params) {
          params.api.sizeColumnsToFit();
          params.api.setRowData($scope.consumer_list || []);
        },
        onCellClicked: function (event) {
          if (event && event.data && event.column.colId == "0") {
            if (event.data.isApproved) {
              return;
            }
            if (!event.data.isApproved && event.data.status === "Yes") {
              var consumerDet = event.data;
              $scope.$apply(function () {
                $scope.approve(consumerDet);
              });
            }
          }
        },
        onFirstDataRendered: function (params) {
          params.api.sizeColumnsToFit();
        }
      };
    })();

    //Approve Button Functionality
    function ApproveCellRenderer() {
    }

    ApproveCellRenderer.prototype.init = function (params) {
      this.eGui = document.createElement('div');
      var iconsDiv;
      if (params.data.isApproved && params.data.status == "Yes") {
        iconsDiv = `<button style="padding: 2px 4px; background-color: green; cursor: default;" class="btn btn-default fa fa-check waves-effect waves-light pull-right" title="Already approved as customer"></button>`;
      } else if (!params.data.isApproved && params.data.status == "Yes") {
        iconsDiv = `<button style="padding: 2px 4px; color: #5fbeaa; background-color: white; border: 1px solid #5fbeaa; cursor: pointer;" class="btn fa fa-ellipsis-h waves-effect waves-light pull-right changecursor" title="Click to approve and convert to ${params.data.userType || 'Customer'}"></button>`;
      } else {
        iconsDiv = `<button style="padding: 2px 4px; color: red; background-color: white; cursor: default;" class="btn fa fa-ban waves-effect waves-light pull-right" title="Not interested — cannot approve"></button>`;
      }
      this.eGui.innerHTML = iconsDiv;
    };

    ApproveCellRenderer.prototype.getGui = function () {
      return this.eGui;
    };

    // ---- data ----

    var subAreas = null;
    function getSubAreas() {
      if (subAreas) {
        return Promise.resolve(subAreas);
      }
      return dashboard.getAllCity().then(function (res) {
        var list = [];
        if (res && res.status === 'SUCCESS' && res.data && res.data.cities) {
          $rootScope.allCityData = res.data.cities;
          res.data.cities.forEach(function (elem) {
            if (elem.name === $rootScope.loginData.city && list.indexOf(elem.subarea) < 0) {
              list.push(elem.subarea);
            }
          });
        }
        subAreas = list;
        return list;
      });
    }

    function buildRequest(areas) {
      var request = {
        status: $scope.filters.status,
        sort: { byCreatedDate: -1 },
        skip: ($scope.pager.page - 1) * PAGE_SIZE,
        limit: PAGE_SIZE,
        subAreasOfCurrentCity: areas
      };
      if ($scope.filters.approval === 'approved') {
        request.isApproved = true;
      } else if ($scope.filters.approval === 'not_approved') {
        request.isApproved = false;
      }
      if ($scope.date && $scope.date.startDate && $scope.date.endDate &&
        $moment($scope.date.startDate).isValid() && $moment($scope.date.endDate).isValid()) {
        request.fromDate = $moment($scope.date.startDate).format('DD-MMM-YYYY');
        request.toDate = $moment($scope.date.endDate).format('DD-MMM-YYYY');
      }
      if ($scope.salesApiUpdated && $scope.filters.search && $scope.filters.search.trim()) {
        request.search = $scope.filters.search.trim();
      }
      return request;
    }

    function mapRows(rows) {
      (rows || []).forEach(function (row) {
        if (row.status == "INTERESTED") {
          row.status = "Yes";
        } else if (row.status == "NOTINTERESTED") {
          row.status = "No";
        }
        try {
          var parts = row.address.formattedAddress.split(/\,+/);
          row.area = parts[parts.length - 4].trim() + ", " + parts[parts.length - 3].trim();
        } catch (e) {
          // no usable address
        }
      });
      return rows || [];
    }

    var requestId = 0;
    $scope.loadConsumer = function () {
      var mine = ++requestId; // only the newest request updates the page
      $scope.loading = true;
      $scope.loadError = false;
      getSubAreas().then(function (areas) {
        return consumer.loadConsumer(buildRequest(areas));
      }).then(function (res) {
        if (mine !== requestId) {
          return;
        }
        if (!res || res.status !== 'Success') {
          throw new Error((res && res.message) || 'search failed');
        }
        var lastPage = Math.max(1, Math.ceil((res.total || 0) / PAGE_SIZE));
        if ($scope.pager.page > lastPage) {
          // the page no longer exists (fewer results now, or an old link): show the last one
          $scope.$applyAsync(function () {
            $scope.pager.page = lastPage;
            $scope.loadConsumer();
          });
          return;
        }
        $scope.$applyAsync(function () {
          $scope.consumer_list = mapRows(res.data);
          $scope.listTotal = res.total || 0;
          // tiles: counts for the current filters (Interested / Not Interested ignore the interest filter,
          // Approved ignores the approval filter), so each tile equals the list total when it is clicked
          $scope.counts.interested = res.completed || 0;
          $scope.counts.notInterested = res.pending || 0;
          $scope.counts.total = $scope.counts.interested + $scope.counts.notInterested;
          $scope.counts.approved = res.approved || 0;
          $scope.loading = false;
          if ($scope.gridOptions.api) {
            $scope.gridOptions.api.setRowData($scope.consumer_list);
          }
        });
      }).catch(function (err) {
        console.error('Error loading acquisitions', err);
        $scope.$applyAsync(function () {
          if (mine === requestId) {
            $scope.loading = false;
            $scope.loadError = true;
          }
        });
      });
    };

    // a change of filters starts again on page 1
    function filtersChanged() {
      $scope.pager.page = 1;
      $scope.loadConsumer();
    }

    // the theme paints btn-default green too: the selected option is filled, the others white
    $scope.optionStyle = function (selected) {
      return selected ? { "background-color": "#21a548", "border-color": "#21a548", "color": "#fff" }
        : { "background-color": "#fff", "border-color": "#ccc", "color": "#555" };
    };

    $scope.setStatus = function (value) {
      $scope.filters.status = value;
      filtersChanged();
    };
    $scope.setApproval = function (value) {
      $scope.filters.approval = value;
      filtersChanged();
    };
    // tiles
    $scope.tileClicked = function (tile) {
      if (tile === 'total') {
        $scope.filters.status = STATUS.ALL;
      } else if (tile === 'interested') {
        $scope.filters.status = STATUS.INTERESTED;
      } else if (tile === 'notInterested') {
        $scope.filters.status = STATUS.NOT_INTERESTED;
      } else if (tile === 'approved') {
        $scope.filters.approval = 'approved';
      }
      filtersChanged();
    };
    $scope.isTileActive = function (tile) {
      switch (tile) {
        case 'total': return $scope.filters.status === STATUS.ALL;
        case 'interested': return $scope.filters.status === STATUS.INTERESTED;
        case 'notInterested': return $scope.filters.status === STATUS.NOT_INTERESTED;
        case 'approved': return $scope.filters.approval === 'approved';
      }
      return false;
    };
    // search: after typing stops
    var searchTimer = null;
    $scope.searchChanged = function () {
      if (searchTimer) {
        clearTimeout(searchTimer);
      }
      searchTimer = setTimeout(function () {
        $scope.$applyAsync(function () {
          if ($scope.filters.search !== $scope.searchText) {
            $scope.filters.search = $scope.searchText;
            filtersChanged();
          }
        });
      }, 500);
    };
    $scope.pageChanged = function () {
      $scope.loadConsumer();
    };
    $scope.reset = function () {
      $scope.filters.status = STATUS.ALL;
      $scope.filters.approval = 'not_approved';
      $scope.filters.search = '';
      $scope.searchText = '';
      $scope.date = { startDate: null, endDate: null };
      filtersChanged();
    };
    $scope.lastRow = function () {
      return Math.min($scope.pager.page * PAGE_SIZE, $scope.listTotal);
    };

    //Date picker configaration
    $scope.opts = {
      locale: {
        applyClass: 'btn-green',
        applyLabel: "Apply",
        fromLabel: "From",
        format: "DD-MMM-YYYY",
        toLabel: "To",
        cancelLabel: 'Cancel',
        customRangeLabel: 'Custom range'
      },
      ranges: {
        'Today': [moment(), moment()],
        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')]
      }
    };
    $scope.clearDates = function () {
      $scope.date = { startDate: null, endDate: null };
    };

    // filters and page in the URL: Back / refresh / a shared link show the same list
    tableState.page($scope, 'q', {
      controls: {
        d: { model: 'date', type: 'daterange', onRestore: function () { restoringDates = true; } },
        s: {
          model: 'filters.status', type: 'string',
          validate: function (v) { return [STATUS.ALL, STATUS.INTERESTED, STATUS.NOT_INTERESTED].indexOf(v) >= 0; },
          onRestore: function () { $scope.loadConsumer(); }
        },
        a: {
          model: 'filters.approval', type: 'string',
          validate: function (v) { return ($scope.salesApiUpdated ? ['all', 'approved', 'not_approved'] : ['approved', 'not_approved']).indexOf(v) >= 0; },
          onRestore: function () { $scope.loadConsumer(); }
        },
        q: {
          model: 'filters.search', type: 'string', history: 'search',
          validate: function (v) { return $scope.salesApiUpdated || !v; },
          onRestore: function (v) { $scope.searchText = v || ''; $scope.loadConsumer(); }
        },
        p: {
          model: 'pager.page', type: 'int', history: 'replace',
          validate: function (v) { return v >= 1; },
          onRestore: function () { $scope.loadConsumer(); }
        }
      },
      grids: { g: 'gridOptions' }
    });
    $scope.searchText = $scope.filters.search || '';

    // dates: the first value comes from the URL; later changes reload from page 1
    var firstDates = true;
    var restoringDates = false; // dates set from the URL (Back / Forward) keep the URL's page
    $scope.$watch('date', function () {
      if (firstDates) {
        firstDates = false;
        return;
      }
      if (restoringDates) {
        restoringDates = false;
        $scope.loadConsumer();
        return;
      }
      filtersChanged();
    }, true);

    $scope.loadConsumer();

    // a lead becomes a customer: a business keeps its name as the customer's name and the lead's person as its
    // contact; a lead without a business name (e.g. a home) keeps the person's name as the customer's name
    function openAsCustomer(items) {
      var personName = items.name ? String(items.name).trim() : '';
      var businessName = items.organizationName ? String(items.organizationName).trim() : '';
      items.name = businessName || personName;
      items.contact = businessName && personName && personName.toLowerCase() !== businessName.toLowerCase() ? personName : '';
      items.categories = [items.categories];
      consumer.setConsumerDetails(items);
      $state.go("root.add-consumer");
    }

    //Approve
    $scope.approve = function (consumerDet) {

      let items = consumerDet;
      items.referrer = "Aquisitions";

      var resolvedType = consumerDet.userType || 'Customer';

      if (resolvedType === "Customer") {
        openAsCustomer(items);
      } else if (resolvedType === "Partner") {
        items.passCode = items.password;
        items.emailId = items.email;
        items.pannumber = items.panNumber;
        items.upiId = items.upiID;
        items.bankaccountnumber = items.accountNumber;
        items.ifsccode = items.ifsc;
        wholesalerService.setSalesDetails(items);
        $state.go("root.add-reo", { type: "WHOLESALER", fromPage: "root.aquisitions" });
      } else if (resolvedType === "Agent" || resolvedType === "REO") {
        items.passCode = items.password;
        items.emailId = items.email;
        items.pannumber = items.panNumber;
        items.upiId = items.upiID;
        items.bankaccountnumber = items.accountNumber;
        items.ifsccode = items.ifsc;
        wholesalerService.setSalesDetails(items);
        $state.go("root.add-reo", { type: "AGENT", fromPage: "root.aquisitions" });
      } else if (resolvedType === "Vendor") {
        items.passCode = items.password;
        items.emailId = items.email;
        items.pannumber = items.panNumber;
        items.upiId = items.upiID;
        items.bankaccountnumber = items.accountNumber;
        items.ifsccode = items.ifsc;
        wholesalerService.setSalesDetails(items);
        $state.go("root.add-vendor", { fromPage: "root.aquisitions", type: "ADD" });
      } else {
        openAsCustomer(items);
      }
    }

  });
